export default {
    methods: {
        _falloResponse(err) {
            this.cargando = false;
            if (err.status === 401) {
                this.$router.push("/login");
            } else if ('error' in err.body) {
                this.$emit("msg", err.body.error);
            } else {
                this.$emit("msg", this.$no_internet);
            }
        },
    }
}